import React from 'react';
import { Helmet } from 'react-helmet';
import { globalService as gs } from '../common/services';


export const DocumentTitle = ({ title, description }) => {
    var defaultTitle = gs.siteTitle();
    var defaultDescription = 'This is a different description for this route.';
    return (
        <Helmet>
            <title>{title ? `${defaultTitle} | ${title}` : defaultTitle}</title>
            <meta name="description" content={description ? description : defaultDescription} />
        </Helmet>
    );
};